import { useEffect, useMemo, useState } from "react";

export default function EtvSpotlight({ v2Masjids = [] }) {
  const posters = useMemo(
    () => v2Masjids.flatMap((masjid) => {
      const images = masjid.etv?.etvImage || masjid.etvImages || [];
      const src = images.find(Boolean);
      const name = masjid.profail?.nama || masjid.name || "Masjid";
      const logo = masjid.profail?.logo || masjid.profail?.logoJa || masjid.photo_src || "";
      return src ? [{ src, name, logo }] : [];
    }),
    [v2Masjids]
  );
  const [activeIndex, setActiveIndex] = useState(0);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => setActiveIndex(0), [posters]);

  useEffect(() => {
    if (posters.length < 2) return undefined;
    const timer = window.setInterval(
      () => setActiveIndex((index) => (index + 1) % posters.length),
      15000
    );
    return () => window.clearInterval(timer);
  }, [posters.length]);

  if (!posters.length) return null;
  const poster = posters[activeIndex % posters.length];

  return (
    <section className="home-etv-spotlight" aria-label="Poster ETV terkini">
      <div className="home-reading-label">POSTER ETV</div>
      <button
        type="button"
        className="home-etv-poster"
        onClick={() => setExpanded(true)}
        aria-label={`Lihat poster ETV ${poster.name}`}
      >
        <img className="home-etv-image" src={poster.src} alt={`Poster ETV ${poster.name}`} />
        {poster.logo && (
          <span className="home-etv-logo-wrap">
            <img src={poster.logo} alt={`Logo ${poster.name}`} />
          </span>
        )}
      </button>

      {expanded && (
        <div
          className="etv-lightbox"
          role="dialog"
          aria-modal="true"
          aria-label="Paparan poster ETV"
          onClick={() => setExpanded(false)}
        >
          <img
            src={poster.src}
            alt={`Poster ETV ${poster.name}`}
            className="etv-lightbox-img"
            onClick={(event) => event.stopPropagation()}
          />
        </div>
      )}
    </section>
  );
}
